//https://github.com/bowser-js/bowser/blob/master/src/constants.js

const deviceTypes = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
};

const operatingSystemNames = {
    ANDROID: 'android',
    IOS: 'ios',
    MACOS: 'macos',
};

const browserTypes = {
    SAFARI: 'safari',
    CHROME: 'chrome',
};

export default {
    ...operatingSystemNames,
    ...deviceTypes,
    ...browserTypes,
};
